import { WeatherIcon } from '@core/api/weather.enums';

import { WeatherIconStoreModelEnum } from './weather.enums';

export const mapWeatherIconApiModelToStoreModel = (weatherIcon: WeatherIcon): WeatherIconStoreModelEnum => {
  const mapping: Record<WeatherIcon, WeatherIconStoreModelEnum> = {
    [WeatherIcon.ClearDay]: WeatherIconStoreModelEnum.ClearDay,
    [WeatherIcon.ClearNight]: WeatherIconStoreModelEnum.ClearNight,
    [WeatherIcon.Thunderstorm]: WeatherIconStoreModelEnum.Thunderstorm,
    [WeatherIcon.Rain]: WeatherIconStoreModelEnum.Rain,
    [WeatherIcon.Snow]: WeatherIconStoreModelEnum.Snow,
    [WeatherIcon.Sleet]: WeatherIconStoreModelEnum.Sleet,
    [WeatherIcon.Wind]: WeatherIconStoreModelEnum.Wind,
    [WeatherIcon.Fog]: WeatherIconStoreModelEnum.Fog,
    [WeatherIcon.Cloudy]: WeatherIconStoreModelEnum.Cloudy,
    [WeatherIcon.PartlyCloudyDay]: WeatherIconStoreModelEnum.PartlyCloudyDay,
    [WeatherIcon.PartlyCloudyNight]: WeatherIconStoreModelEnum.PartlyCloudyNight,
    [WeatherIcon.Hail]: WeatherIconStoreModelEnum.Hail,
    [WeatherIcon.None]: WeatherIconStoreModelEnum.None,
  };

  return mapping[weatherIcon];
};
